import { Expose, Transform, Type } from 'class-transformer';
import { SurveyEntity } from '@core/entities/surveys.entity';
import { SafeUrl } from '@angular/platform-browser';
import { UserEntity } from '@core/entities/user.entity';

export class SurveyPushNotificationEntity {
  id: number;

  @Expose({ name: 'survey_id' })
  surveyId: number;

  @Expose({ name: 'survey' })
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  surveyTitle: string;

  author: number;

  @Expose({ name: 'to_user' })
  @Transform(({ value }) => (value ? JSON.parse(value) : null))
  toUsers: { userId: number; status: number }[];

  timestamp: string;

  @Expose({ name: 'surveys' })
  @Type(() => SurveyEntity)
  survey: SurveyEntity;
}

export class CRMNewsPushNotificationEntity {
  id: number;

  @Expose({ name: 'news_id' })
  newsId: number;

  @Expose({ name: 'author_id' })
  authorId: number;

  @Expose({ name: 'author' })
  authorName: string;

  picture: string; // long string as base64
  image: string; // long string as base64

  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  title: string;

  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  content: string;

  @Expose({ name: 'user_name' })
  @Type(() => UserEntity)
  user: UserEntity;

  @Expose({ name: 'created_at' })
  createdAt: string;

  // For UI purposes
  imageUrl: SafeUrl | string;
  authorImageUrl: SafeUrl | string;
}
